import { render, staticRenderFns } from "./Model3D.vue?vue&type=template&id=5128d680&scoped=true"
import script from "./Model3D.vue?vue&type=script&lang=js"
export * from "./Model3D.vue?vue&type=script&lang=js"
import style0 from "./Model3D.vue?vue&type=style&index=0&id=5128d680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128d680",
  null
  
)

export default component.exports